import { HorizontalContainer } from '@american-autonomy/ag-ui';

import TriangleArrowIcon from 'components/icons/TriangleArrowIcon';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WithArrow: FunctionComponent<Props> = ({
    children,
    className = '',
    onClick,
    testId = TEST_ID
}) => (
    <HorizontalContainer
        className={`${className} ${styles.withArrow}`}
        onClick={onClick}
        testId={testId}>
        {children}

        <TriangleArrowIcon className={styles.triangleArrowIcon} />
    </HorizontalContainer>
);

export default WithArrow;
